import "./app.scss";
import { html } from "lit";
import ComponentBase from "../../common-components/component-base";
// components
import "../../common-components/component-cart";
import "../../common-components/component-products";
import SettingsModal from "../../common-components/settings-modal";
import "./components/cart";
import "./components/header";
import { addItemToCart, configShowPrices } from "./redux/actions";

class InCassaApp extends ComponentBase {
  static get tagName() {
    return "incassa-app";
  }

  constructor() {
    super();
  }

  connectedCallback(): void {
    super.connectedCallback();
    configShowPrices();
  }

  async OnSettings() {
    await SettingsModal.Show();
  }

  render() {
    return html`
      <ncx-shop-header></ncx-shop-header>
      <div class="container-fluid">
        <component-products
          @addToCart=${(e) => {
        this.AddToCart(e.detail.product);
      }}
          .columns=${2}
        ></component-products>
      </div>
      <ncx-shop-cart></ncx-shop-cart>
    `;
  }

  AddToCart(item) {
    addItemToCart({ ...item });
  }
}
InCassaApp.Register();
export default InCassaApp;
